var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOutlookLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 28 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M27.95 13.6501C27.9515 13.4316 27.8386 13.2282 27.6523 13.1139H27.649L27.6373 13.1074L17.9523 7.37438C17.9105 7.34613 17.8671 7.3203 17.8223 7.29704C17.4484 7.10411 17.0042 7.10411 16.6302 7.29704C16.5854 7.32031 16.542 7.34613 16.5002 7.37438L6.81525 13.1074L6.80355 13.1139C6.50755 13.2979 6.41681 13.6871 6.60088 13.9831C6.65511 14.0704 6.72981 14.143 6.8185 14.1948L16.5035 19.9278C16.5455 19.9558 16.5889 19.9817 16.6335 20.0052C17.0074 20.1981 17.4516 20.1981 17.8256 20.0052C17.8702 19.9817 17.9136 19.9558 17.9556 19.9278L27.6406 14.1948C27.8341 14.082 27.9522 13.8741 27.95 13.6501Z",
    fill: "#0A2767"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.9443 9.82214H14.3V15.6481H7.9443V9.82214ZM26.65 3.9V1.23499C26.6653 0.568682 26.1378 0.0159663 25.4716 0H8.97846C8.31215 0.0159663 7.78474 0.568682 7.80001 1.23499V3.9L17.55 6.49999L26.65 3.9Z",
    fill: "#0364B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.79999 3.8999H14.3V9.7499H7.79999V3.8999Z",
    fill: "#0078D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8 3.8999H14.3V9.7499L20.8 15.5999H26.65V9.7499L20.8 3.8999Z",
    fill: "#28A8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3 9.75H20.8V15.6H14.3V9.75Z",
    fill: "#0078D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3 15.6001H20.8V21.4501H14.3V15.6001Z",
    fill: "#0364B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.94427 15.6479H14.3V20.9441H7.94427V15.6479Z",
    fill: "#14447D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8 15.6001H26.65V21.4501H20.8V15.6001Z",
    fill: "#0078D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6523 14.1589L27.6399 14.1654L17.9549 19.6123C17.9127 19.6383 17.8698 19.663 17.8249 19.6851C17.6604 19.7635 17.4818 19.8077 17.2997 19.8151L16.7706 19.5057C16.7259 19.4833 16.6825 19.4583 16.6406 19.431L6.82565 13.8293H6.8211L6.5 13.6499V24.6765C6.50501 25.4122 7.10527 26.0046 7.84094 25.9999H26.6298C26.6409 25.9999 26.6506 25.9947 26.6623 25.9947C26.8177 25.9848 26.9709 25.9528 27.1173 25.8998C27.1806 25.873 27.2417 25.8413 27.3 25.8049C27.3435 25.7802 27.4183 25.7263 27.4183 25.7263C27.7512 25.4799 27.9483 25.0907 27.95 24.6765V13.6499C27.9498 13.8608 27.836 14.0553 27.6523 14.1589Z",
    fill: "url(#paint0_linear_1282_385)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M27.43 13.6064V14.2824L17.303 21.2549L6.8185 13.8339C6.8185 13.8303 6.81559 13.8274 6.812 13.8274L5.85001 13.2489V12.7614L6.24651 12.7549L7.085 13.2359L7.10449 13.2424L7.17599 13.2879C7.17599 13.2879 17.03 18.9104 17.056 18.9234L17.433 19.1444C17.4655 19.1314 17.498 19.1184 17.537 19.1054C17.5565 19.0924 27.3195 13.5999 27.3195 13.5999L27.43 13.6064Z",
    fill: "#0A2767"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6523 14.1589L27.6399 14.166L17.9549 19.613C17.9127 19.639 17.8698 19.6637 17.8249 19.6858C17.4488 19.8695 17.0089 19.8695 16.6328 19.6858C16.5883 19.6637 16.5449 19.6394 16.5028 19.613L6.81785 14.166L6.80615 14.1589C6.61917 14.0575 6.50194 13.8626 6.5 13.6499V24.6765C6.50466 25.412 7.10471 26.0045 7.84024 25.9999C7.84024 25.9999 7.84027 25.9999 7.8403 25.9999H26.6097C27.3452 26.0046 27.9453 25.4121 27.95 24.6766C27.95 24.6766 27.95 24.6765 27.95 24.6765V13.6499C27.9497 13.8608 27.836 14.0553 27.6523 14.1589Z",
    fill: "#1490DF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M18.096 19.5327L17.951 19.614C17.909 19.6407 17.8656 19.6652 17.821 19.6874C17.6613 19.7658 17.4877 19.8118 17.3102 19.8226L20.995 24.1802L27.4228 25.7292C27.599 25.5961 27.7391 25.4212 27.8304 25.2202L18.096 19.5327Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M18.7525 19.1631L17.951 19.6135C17.909 19.6403 17.8656 19.6648 17.821 19.687C17.6613 19.7654 17.4877 19.8113 17.3102 19.8222L19.0365 24.5821L27.4248 25.7268C27.7552 25.4787 27.9498 25.0896 27.95 24.6764V24.534L18.7525 19.1631Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.8585 25.9999H26.6077C26.8962 26.0014 27.1776 25.9102 27.4105 25.7399L16.77 19.5071C16.7253 19.4846 16.6819 19.4597 16.64 19.4323L6.82499 13.8306H6.82044L6.5 13.6499V24.6388C6.49927 25.3898 7.10748 25.9992 7.8585 25.9999V25.9999Z",
    fill: "#28A8EA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M15.6 6.39164V20.2561C15.5988 20.7422 15.3033 21.1792 14.8525 21.3611C14.7129 21.4211 14.5625 21.4521 14.4105 21.4521H6.5V5.85019H7.8V5.2002H14.4105C15.0672 5.20268 15.5986 5.73498 15.6 6.39164Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M14.95 7.0416V20.9061C14.9516 21.0631 14.9183 21.2185 14.8525 21.3611C14.672 21.806 14.2407 22.0979 13.7605 22.1001H6.5V5.85015H13.7605C13.9491 5.84826 14.135 5.8953 14.3 5.98666C14.6984 6.1874 14.9498 6.59544 14.95 7.0416Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M14.95 7.0416V19.6061C14.9468 20.2624 14.4169 20.7944 13.7605 20.8001H6.5V5.85015H13.7605C13.9491 5.84826 14.135 5.8953 14.3 5.98666C14.6984 6.1874 14.9498 6.59544 14.95 7.0416Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M14.3 7.04154V19.606C14.2993 20.2634 13.7679 20.7969 13.1105 20.8001H6.5V5.8501H13.1105C13.7678 5.85045 14.3003 6.3836 14.3 7.0409C14.3 7.04112 14.3 7.04133 14.3 7.04154Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.19145 5.8501H13.1085C13.7666 5.8501 14.3 6.38353 14.3 7.04154V18.9586C14.3 19.6167 13.7666 20.1501 13.1085 20.1501H1.19145C0.533422 20.1501 0 19.6166 0 18.9586V7.04154C0 6.38353 0.533437 5.8501 1.19145 5.8501Z",
    fill: "url(#paint1_linear_1282_385)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.72385 10.8471C4.0175 10.2214 4.49148 9.69783 5.08495 9.34361C5.74218 8.96733 6.49049 8.77975 7.2475 8.8015C7.94912 8.78628 8.64144 8.96414 9.24885 9.31565C9.81995 9.65622 10.2799 10.1552 10.5729 10.7521C10.892 11.4099 11.051 12.1337 11.037 12.8646C11.0525 13.6285 10.8888 14.3854 10.5593 15.0746C10.2593 15.6929 9.78473 16.2097 9.19425 16.5612C8.56343 16.9235 7.8454 17.106 7.11816 17.089C6.40155 17.1063 5.69396 16.9264 5.0726 16.569C4.49657 16.228 4.03084 15.7284 3.73101 15.1299C3.41003 14.4817 3.24912 13.7659 3.26171 13.0427C3.24834 12.2854 3.40632 11.5348 3.72385 10.8471ZM5.17465 14.3765C5.33121 14.7721 5.59671 15.1151 5.94034 15.3658C6.29035 15.6105 6.70946 15.7367 7.13634 15.7259C7.59095 15.7439 8.03906 15.6134 8.41294 15.3541C8.75222 15.1042 9.01075 14.7602 9.15653 14.3648C9.31951 13.9233 9.39994 13.4555 9.39378 12.9849C9.39882 12.5098 9.32322 12.0372 9.17018 11.5874C9.03502 11.1813 8.78482 10.8231 8.44999 10.5565C8.08548 10.285 7.63857 10.1472 7.18443 10.1665C6.74831 10.1552 6.31981 10.2824 5.96049 10.5298C5.61105 10.7816 5.34051 11.1277 5.18049 11.5276C4.82552 12.4442 4.82368 13.46 5.17529 14.3778L5.17465 14.3765Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8 3.8999H26.65V9.7499H20.8V3.8999Z",
    fill: "#50D9FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1282_385",
    x1: 17.225,
    y1: 13.6499,
    x2: 17.225,
    y2: 25.9999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#35B8F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#28A8EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1282_385",
    x1: 2.4842,
    y1: 4.91913,
    x2: 11.8158,
    y2: 21.0811,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1784D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#107AD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A63C9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1282_385"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.95,
    height: 26,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutlookLogo);
export default __webpack_public_path__ + "static/media/outlook_logo.4949937f436a84280961d4a2f5353e59.svg";
export { ForwardRef as ReactComponent };